import { flowIdAskaTravelOffer } from '../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../flows/src/hooks/useFlowsResetState';

const useStartAskaTravelOfferFlow = () => {
  const { initFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();

  return async (
    uuid?: string,
    inputUrl?: string,
    partyId?: string,
    quoteId?: string,
  ) => {
    reset();

    await initFlow({
      flowId: flowIdAskaTravelOffer,
      payload: {
        party_id: partyId,
        quote_id: quoteId,
      },
      inputUrl,
      outputUrl: `/sales-conversation/offers/overview/travel`,
      sessionId: uuid,
      shouldComplete: false,
    });
  };
};

export default useStartAskaTravelOfferFlow;
